(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seil-investor-relations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seil-investor-hub')) {
    customElements.define('seil-investor-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const cards = [...this.querySelectorAll('[data-report]')];
        const search = this.querySelector('[data-search]');
        const category = this.querySelector('select[data-category]');
        const year = this.querySelector('select[data-year]');
        const fill = (select, key) => [...new Set(cards.map(card => card.dataset[key]).filter(Boolean))].sort((a,b) => b.localeCompare(a, undefined, {numeric:true})).forEach(value => select.add(new Option(value,value)));
        if (search && category && year) {
        fill(category,'category'); fill(year,'year');
        const filter = () => {
          let count = 0;
          const query = search.value.trim().toLocaleLowerCase();
          cards.forEach(card => {
            const match = (!category.value || card.dataset.category === category.value) && (!year.value || card.dataset.year === year.value) && card.dataset.searchText.toLocaleLowerCase().includes(query);
            card.hidden = !match; if (match) count++;
          });
          this.querySelector('[data-status]').textContent = count + ' ' + this.dataset.countLabel;
          this.querySelector('[data-no-results]').hidden = count !== 0;
        };
        const filters = this.querySelector('.seil-ir__filters');
        if (cards.length && filters.dataset.enabled === 'true') filters.hidden = false;
        search.addEventListener('input',filter); category.addEventListener('change',filter); year.addEventListener('change',filter);
        this.querySelector('[data-reset]').addEventListener('click',() => { search.value=''; category.value=''; year.value=''; filter(); search.focus(); });
        if (cards.length) filter();
        }
        const dialog = this.querySelector('dialog');
        if (typeof dialog.showModal !== 'function') return;
        let trigger, loadingTask, pdf, rendering, generation = 0, renderSequence = 0, currentPage = 1;
        const host = this.querySelector('[data-frame-host]');
        const canvas = host.querySelector('canvas');
        const pageInput = this.querySelector('[data-page]');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const zoom = this.querySelector('[data-zoom]');
        const status = this.querySelector('[data-reader-status]');
        const controls = this.querySelector('.seil-ir__reader-controls');
        const render = async () => {
          if (!pdf) return;
          const token = generation, ticket = ++renderSequence;
          currentPage = Math.min(pdf.numPages,Math.max(1,Number(pageInput.value) || 1));
          pageInput.value = currentPage;
          previous.disabled = currentPage === 1; next.disabled = currentPage === pdf.numPages;
          status.textContent = this.dataset.loading;
          try {
            if (rendering) { rendering.cancel(); try { await rendering.promise; } catch (_) {} }
            const page = await pdf.getPage(currentPage);
            if (token !== generation || ticket !== renderSequence) return;
            const initial = page.getViewport({scale:1});
            const width = Math.max(240,host.clientWidth-32);
            const viewport = page.getViewport({scale:width / initial.width * Number(zoom.value)});
            const ratio = Math.min(window.devicePixelRatio || 1,2);
            canvas.width = Math.floor(viewport.width*ratio); canvas.height = Math.floor(viewport.height*ratio);
            canvas.style.width = viewport.width+'px'; canvas.style.height = viewport.height+'px';
            canvas.setAttribute('aria-label',this.querySelector('[data-dialog-title]').textContent+' — '+currentPage+' / '+pdf.numPages);
            rendering = page.render({canvasContext:canvas.getContext('2d'),viewport,transform:ratio===1?null:[ratio,0,0,ratio,0,0]});
            await rendering.promise;
            if (token === generation && ticket === renderSequence) { canvas.hidden=false; status.textContent=currentPage+' / '+pdf.numPages; host.scrollTop=0; }
          } catch (error) { if (token===generation && ticket===renderSequence && error.name!=='RenderingCancelledException') status.textContent=this.dataset.error; }
        };
        previous.addEventListener('click',()=>{pageInput.value=currentPage-1;render();});
        next.addEventListener('click',()=>{pageInput.value=currentPage+1;render();});
        pageInput.addEventListener('change',render); zoom.addEventListener('change',render);
        this.querySelectorAll('[data-preview]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click',async () => {
            const url = new URL(button.dataset.preview,location.href);
            if (url.protocol !== 'https:') return;
            trigger = button;
            this.querySelector('[data-dialog-title]').textContent = button.dataset.title;
            this.querySelector('[data-dialog-link]').href = url.href;
            const token = ++generation;
            currentPage=1;pageInput.value=1;zoom.value='1';canvas.hidden=true;controls.hidden=true;
            status.textContent=this.dataset.loading;
            dialog.showModal();
            try {
              const library = await import(this.dataset.pdfModule);
              if (token !== generation) return;
              library.GlobalWorkerOptions.workerSrc=this.dataset.pdfWorker;
              loadingTask=library.getDocument({url:url.href,isEvalSupported:false,disableAutoFetch:true});
              pdf=await loadingTask.promise;
              if (token !== generation) return;
              pageInput.max=pdf.numPages;this.querySelector('[data-pages]').textContent='/ '+pdf.numPages;
              controls.hidden=false;await render();
            } catch (error) { console.warn('Report preview:',error.message); if (token === generation) status.textContent=this.dataset.error; }
            this.dispatchEvent(new CustomEvent('seil:report-preview',{bubbles:true,detail:{title:button.dataset.title,url:url.href}}));
          });
        });
        this.querySelector('[data-close]').addEventListener('click',() => dialog.close());
        dialog.addEventListener('close',() => { generation++;rendering?.cancel();loadingTask?.destroy();loadingTask=null;pdf=null;canvas.hidden=true;canvas.width=0;canvas.height=0;trigger?.focus(); });
      }
      disconnectedCallback() { const dialog=this.querySelector('dialog'); if(dialog?.open) dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
